import cx from 'classnames'
import { X } from 'lucide-react'

import { Icon } from '../Icon'
import { IconButton } from '../IconButton'

export const ModalHeader = ({ children, className, id, toggle, ...props }) => (
  <div className={cx('tw:flex tw:items-center tw:justify-between tw:border-b tw:border-default tw:px-5 tw:py-4', className)} {...props}>
    <h2 className="ds-heading-3" id={id}>{children}</h2>
    {toggle && (
      <IconButton label="Close Dialog" onClick={toggle}>
        <Icon as={X} />
      </IconButton>
    )}
  </div>
)
